import { DvaReducer, WholeReadonly } from '@/models/shared';
import { AnyAction } from 'umi';
import { EffectsCommandMap, Subscription } from 'dva';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import dayjs from 'dayjs';
export interface ActivityDetailsPageModelState {
  pageState: 'loading' | 'loaded' | 'noDate';
  activityID: string;
  pageTitle: string;
  cover: string;
  showActivity:
    | ''
    | 'play-newer'
    | 'ResourceCompetition'
    | 'invite-friend'
    | 'Questionnaire'
    | 'ExperienceOfficer'
    | 'SpringFestival'
    | 'event_editorpick'
    | 'event_contest202409'
    | 'SpringFestival2025'
    | 'Widget'
    | 'MoonFestival2025'
    | 'SpringFestival2026'
    | 'PaymentSubsidy';

  startTime: dayjs.Dayjs | null;
  endTime: dayjs.Dayjs | null;
  announceTime: dayjs.Dayjs | null;
  timeValidity: 'NotStart' | 'Validity' | 'Finished';
  description: string;
  activityDateTime: {
    collecting_startTime: dayjs.Dayjs | null;
    collecting_endTime: dayjs.Dayjs | null;
    choosing_startTime: dayjs.Dayjs | null;
    choosing_endTime: dayjs.Dayjs | null;
    announcing: dayjs.Dayjs | null;
  };
}

export interface ChangeAction extends AnyAction {
  type: 'change';
  payload: Partial<ActivityDetailsPageModelState>;
}

export interface OnMountPageAction extends AnyAction {
  type: 'activityDetailsPage/onMountPage';
  payload: {
    activityID: string;
  };
}

export interface OnUnmountPageAction extends AnyAction {
  type: 'activityDetailsPage/onUnmountPage';
}

interface ActivityDetailsPageModelType {
  namespace: 'activityDetailsPage';
  state: ActivityDetailsPageModelState;
  effects: {
    onMountPage: (action: OnMountPageAction, effects: EffectsCommandMap) => void;
    onUnmountPage: (action: OnUnmountPageAction, effects: EffectsCommandMap) => void;
  };
  reducers: {
    change: DvaReducer<ActivityDetailsPageModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: ActivityDetailsPageModelState = {
  pageState: 'loading',
  activityID: '',
  pageTitle: '',
  cover: '',
  showActivity: '',

  startTime: null,
  endTime: null,
  announceTime: null,
  timeValidity: 'Validity',

  description: '',
  activityDateTime: {
    collecting_startTime: null,
    collecting_endTime: null,
    choosing_startTime: null,
    choosing_endTime: null,
    announcing: null,
  },
};

const Model: ActivityDetailsPageModelType = {
  namespace: 'activityDetailsPage',
  state: initStates,
  effects: {
    *onMountPage({ payload }: OnMountPageAction, { call, put }: EffectsCommandMap) {
      if (!payload.activityID) {
        return;
      }
      const params: Parameters<typeof FServiceAPI.Activity.find4Client>[0] = {
        _id: payload.activityID,
      };
      const {
        ret,
        errCode,
        data,
      }: {
        ret: number;
        errCode: number;
        data: {
          _id: string;
          title: string;
          cover: string;
          status: 1 | 2 | 3 | 4 | 5;
          persist: boolean;
          link: string;
          startTime: string;
          limitTime: string;
          extraInfo: string;
          intro: string;
        } | null;
      } = yield call(FServiceAPI.Activity.find4Client, params);

      const parsedExtraInfo: {
        gsDate: string | null;
        pjDate: [string | null, string | null];
        zjDate: [string | null, string | null];
      } = data?.extraInfo
        ? JSON.parse(data.extraInfo)
        : {
            gsDate: null,
            pjDate: [null, null],
            zjDate: [null, null],
          };

      if (ret !== 0 || errCode !== 0 || !data) {
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            pageState: 'noDate',
          },
        });
        return;
      }

      if (
        data.link !== 'play-newer' &&
        data.link !== 'ResourceCompetition' &&
        data.link !== 'invite-friend' &&
        data.link !== 'Questionnaire' &&
        data.link !== 'ExperienceOfficer' &&
        data.link !== 'SpringFestival' &&
        data.link !== 'event_editorpick' &&
        data.link !== 'event_contest202409' &&
        data.link !== 'SpringFestival2025' &&
        data.link !== 'Widget' &&
        data.link !== 'MoonFestival2025' &&
        data.link !== 'SpringFestival2026' &&
        data.link !== 'PaymentSubsidy'
      ) {
        self.location.replace(data.link);
        return;
      }

      const nowTimestamp: number = Date.now();


      yield put<ChangeAction>({
        type: 'change',
        payload: {
          pageState: 'loaded',
          activityID: payload.activityID,
          showActivity: data.link || '',
          pageTitle: data.title || '活动不存在或者已暂停',
          cover: data.cover || '',

          startTime: data.persist ? null : dayjs(data.startTime),
          endTime: data.persist ? null : dayjs(data.limitTime),
          // announceTime: dayjs(data.limitTime).add(15, 'days'),
          announceTime: parsedExtraInfo.gsDate ? dayjs(parsedExtraInfo.gsDate) : null,
          timeValidity: data.persist
            ? 'Validity'
            : nowTimestamp < new Date(data.startTime).getTime()
              ? 'NotStart'
              : nowTimestamp > new Date(data.limitTime).getTime()
                ? 'Finished'
                : 'Validity',
          description: data.intro,
          activityDateTime: {
            collecting_startTime: parsedExtraInfo.zjDate[0]
              ? dayjs(parsedExtraInfo.zjDate[0])
              : null,
            collecting_endTime: parsedExtraInfo.zjDate[1] ? dayjs(parsedExtraInfo.zjDate[1]) : null,
            choosing_startTime: parsedExtraInfo.pjDate[0] ? dayjs(parsedExtraInfo.pjDate[0]) : null,
            choosing_endTime: parsedExtraInfo.pjDate[1] ? dayjs(parsedExtraInfo.pjDate[1]) : null,
            announcing: parsedExtraInfo.gsDate ? dayjs(parsedExtraInfo.gsDate) : null,
          },
        },
      });
    },
    *onUnmountPage({}: OnUnmountPageAction, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: initStates,
      });
    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;
